import { useEffect, useRef, useState } from 'react';
import { animate } from 'framer-motion';

interface UseAnimatedNumberOptions {
  duration?: number;
  type?: 'integer' | 'float';
}

export function useAnimatedNumber(value: number, options: UseAnimatedNumberOptions = {}): number {
  const { duration = 0.2, type = 'float' } = options;
  const startValue = useRef(value);
  const [animatedValue, setAnimatedValue] = useState(value);

  useEffect(() => {
    const controls = animate(startValue.current, value, {
      duration,
      ease: 'easeOut',
      onUpdate(value) {
        if (type === 'integer') {
          value = Math.round(value);
        }
        startValue.current = value;
        setAnimatedValue(value);
      },
    });

    return () => controls.stop();
  }, [value, duration, type]);

  return animatedValue;
}
